import type { RouteRecordRaw } from 'vue-router'

export const systemRoutes: RouteRecordRaw[] = [
  {
    path: '/system/enterprises',
    name: 'enterprises',
    component: () => import('./enterprises/pages/EnterprisesPage.vue')
  },
  {
    path: '/system/accounts',
    name: 'accounts',
    component: () => import('./accounts/pages/AccountsPage.vue')
  },
  {
    path: '/system/accounts/:id/edit',
    name: 'account-edit',
    component: () => import('./accounts/pages/AccountEditPage.vue')
  },
  {
    path: '/system/users',
    name: 'users',
    component: () => import('./users/pages/UsersPage.vue')
  },
  {
    path: '/system/users/:id/edit',
    name: 'user-edit',
    component: () => import('./users/pages/UserEditPage.vue')
  },
  {
    path: '/system/api-keys',
    name: 'api-keys',
    component: () => import('./api-keys/pages/ApiKeysPage.vue')
  },
  {
    path: '/system/integrations',
    name: 'integrations',
    component: () => import('./integrations/pages/IntegrationsPage.vue')
  },
  {
    path: '/system/ips-and-ports',
    name: 'ips-and-ports',
    component: () => import('./ips-and-ports/pages/IpsAndPortsPage.vue')
  },
  {
    path: '/system/sip-credentials',
    name: 'sip-credentials',
    component: () => import('./sip-credentials/pages/SipCredentialsPage.vue')
  }
]
